import { ChangeDetectionStrategy, Component, input } from '@angular/core'

@Component({
	selector: 'mos-pack-plate',
	templateUrl: './pack-plate.component.html',
	styleUrl: './pack-plate.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PackPlateComponent {
	label = input('Pack', { transform: (value: string | null): string => value ?? 'Pack' })
	color = input<'bronze' | 'silver' | 'gold' | 'diamond'>('bronze')
}
